var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagingBlockout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#445062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messaging-blockout",
    transform: "translate(-24 -784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-square",
    transform: "translate(24 784)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "message-square-2",
    "data-name": "message-square",
    d: "M22,15V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5V21a1,1,0,0,0,1.707.707L7.414,18H19a3,3,0,0,0,3-3Zm-2,0a1,1,0,0,1-1,1H7a1,1,0,0,0-.707.293L4,18.586V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z",
    transform: "translate(-2 -2)",
    fill: "#05152d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(30 787)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    d: "M5.209,6.219,8.99,10,5.209,13.781a.714.714,0,0,0,1.01,1.01L10,11.01l3.781,3.781a.714.714,0,0,0,1.01-1.01L11.01,10l3.781-3.781a.714.714,0,0,0-1.01-1.01L10,8.99,6.219,5.209a.714.714,0,1,0-1.01,1.01Z",
    transform: "translate(-5 -5)",
    fill: "#05152d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingBlockout);
export default __webpack_public_path__ + "static/media/messaging-blockout.e64c47c8cf8ee874d4b4bc4123150390.svg";
export { ForwardRef as ReactComponent };